<template>
  <ConfigPage max-width="900">
    <v-row class="mt-5">
      <v-col>
        <TextTemplateForm
          title="Fatos Apurados / Fundamentação Técnica"
          id="re-report-established-facts"
        ></TextTemplateForm>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <TextTemplateForm
          title="Sem Enquadramento"
          id="re-report-without-fitting"
        ></TextTemplateForm>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <TextTemplateForm
          title="Com Enquadramento"
          id="re-report-with-fitting"
        ></TextTemplateForm>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <TextTemplateForm
          title="Para Substituição"
          id="re-report-for-substitution"
        ></TextTemplateForm>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <TextTemplateForm
          title="Para Reparação"
          id="re-report-for-reparation"
        ></TextTemplateForm>
      </v-col>
    </v-row>
  </ConfigPage>
</template>

<script>
import ConfigPage from "@/layouts/configs/ConfigPage.vue";
import TextTemplateForm from "@/components/textTemplates/TextTemplateForm.vue";

export default {
  mixins: [],

  components: {
    ConfigPage,
    TextTemplateForm,
  },

  props: {},

  data() {
    return {};
  },

  methods: {},

  computed: {},
};
</script>
